import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

// Set default authorization header if token exists
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// ============ AUTH API ============
export const authApi = {
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password }),
  register: (data) => axios.post(`${API}/auth/register`, data),
  getMe: () => axios.get(`${API}/auth/me`)
};

export const companiesApi = {
  getAll: () => axios.get(`${API}/companies`),
  create: (data) => axios.post(`${API}/companies`, data),
  update: (id, data) => axios.put(`${API}/companies/${id}`, data)
};

export const usersApi = {
  getAll: () => axios.get(`${API}/users`),
  create: (data) => axios.post(`${API}/users`, data),
  update: (id, data) => axios.put(`${API}/users/${id}`, data)
};

export const chargerRequestsApi = {
  getAll: (params) => axios.get(`${API}/charger-requests`, { params }),
  getById: (id) => axios.get(`${API}/charger-requests/${id}`),
  create: (data) => axios.post(`${API}/charger-requests`, data),
  update: (id, data) => axios.put(`${API}/charger-requests/${id}`, data),
  submit: (id) => axios.post(`${API}/charger-requests/${id}/submit`),
  review: (id, data) => axios.post(`${API}/charger-requests/${id}/review`, data),
  startInstallation: (id) => axios.post(`${API}/charger-requests/${id}/installation-start`),
  completeInstallation: (id) => axios.post(`${API}/charger-requests/${id}/installation-complete`),
  activity: (id) => axios.get(`${API}/charger-requests/${id}/activity`),
  comment: (id, data) => axios.post(`${API}/charger-requests/${id}/comments`, data),
  attachments: (id) => axios.get(`${API}/charger-requests/${id}/attachments`),
  upload: (id, file) => {
    const form = new FormData();
    form.append('file', file);
    return axios.post(`${API}/charger-requests/${id}/attachments`, form);
  },
  download: (requestId, attachmentId) => axios.get(`${API}/charger-requests/${requestId}/attachments/${attachmentId}`, { responseType: 'blob' })
};

// ============ CHARGERS API ============
export const chargersApi = {
  getAll: (params) => axios.get(`${API}/chargers`, { params }),
  create: (data) => axios.post(`${API}/chargers`, data),
  getById: (id) => axios.get(`${API}/chargers/${id}`),
  update: (id, data) => axios.put(`${API}/chargers/${id}`, data),
  delete: (id) => axios.delete(`${API}/chargers/${id}`),
  getConnectors: (id) => axios.get(`${API}/chargers/${id}/connectors`),
  getMeterValues: (id, params) => axios.get(`${API}/chargers/${id}/meter-values`, { params })
};

// ============ SESSIONS API ============
export const sessionsApi = {
  getAll: (params) => axios.get(`${API}/sessions`, { params }),
  getById: (id) => axios.get(`${API}/sessions/${id}`),
  getMeterValues: (id) => axios.get(`${API}/sessions/${id}/meter-values`)
};

// ============ TARIFFS API ============
export const tariffsApi = {
  getAll: () => axios.get(`${API}/tariffs`),
  getById: (id) => axios.get(`${API}/tariffs/${id}`),
  create: (data) => axios.post(`${API}/tariffs`, data),
  update: (id, data) => axios.put(`${API}/tariffs/${id}`, data),
  delete: (id) => axios.delete(`${API}/tariffs/${id}`),
  assignToCharger: (tariffId, chargerId) => axios.post(`${API}/tariffs/${tariffId}/assign/${chargerId}`)
};

// ============ ALARMS API ============
export const alarmsApi = {
  getAll: (params) => axios.get(`${API}/alarms`, { params }),
  acknowledge: (id) => axios.post(`${API}/alarms/${id}/ack`),
  clear: (id) => axios.post(`${API}/alarms/${id}/clear`)
};

// ============ COMMANDS API ============
export const commandsApi = {
  remoteStart: (data) => axios.post(`${API}/commands/remote-start`, data),
  remoteStop: (data) => axios.post(`${API}/commands/remote-stop`, data),
  changeAvailability: (params) => axios.post(`${API}/commands/change-availability`, null, { params }),
  reset: (params) => axios.post(`${API}/commands/reset`, null, { params }),
  unlockConnector: (params) => axios.post(`${API}/commands/unlock-connector`, null, { params }),
  clearCache: (params) => axios.post(`${API}/commands/clear-cache`, null, { params }),
  setChargingProfile: (params, profile) => axios.post(`${API}/commands/set-charging-profile`, profile, { params }),
  clearChargingProfile: (params) => axios.post(`${API}/commands/clear-charging-profile`, null, { params }),
  getCompositeSchedule: (params) => axios.post(`${API}/commands/get-composite-schedule`, null, { params })
};

// ============ SETTINGS API ============
export const settingsApi = {
  get: () => axios.get(`${API}/settings`),
  update: (data) => axios.put(`${API}/settings`, data)
};

// ============ ANALYTICS API ============
export const analyticsApi = {
  getDashboard: () => axios.get(`${API}/analytics/dashboard`),
  getEnergyTrend: (params) => axios.get(`${API}/analytics/energy-trend`, { params }),
  getSessionsTrend: (params) => axios.get(`${API}/analytics/sessions-trend`, { params }),
  getRevenueTrend: (params) => axios.get(`${API}/analytics/revenue-trend`, { params }),
  getFaultsTrend: (params) => axios.get(`${API}/analytics/faults-trend`, { params })
};

// ============ OCPP MESSAGES API ============
export const ocppMessagesApi = {
  getAll: (params) => axios.get(`${API}/ocpp-messages`, { params })
};

export default {
  auth: authApi,
  companies: companiesApi,
  users: usersApi,
  chargerRequests: chargerRequestsApi,
  chargers: chargersApi,
  sessions: sessionsApi,
  tariffs: tariffsApi,
  alarms: alarmsApi,
  commands: commandsApi,
  settings: settingsApi,
  analytics: analyticsApi,
  ocppMessages: ocppMessagesApi
};
